import React from 'react';


import Backdrop from './Backdrop';

import styled from 'styled-components';


const LargeModal = styled.div`
    width: 75%;
    height: 93vh;
    position: fixed;
    z-index: 7000;
    box-sizing: border-box;
    padding: 10px;
    top: 5%;
    left: calc(13%);
    background: white;
    border-radius: 5px;
`
const largeModal = (props) => (
   <div>
     <Backdrop clicked={props.closeModal} show={props.show} />
     <LargeModal
     style={{
        transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.show ? '1': '0'

    }}
     >
      {props.children}
    </LargeModal>
   </div>
);

export default largeModal;